import { DateConstant } from '@unistocks/proxy/axios-client';
import { mapEnumToOptions } from '@unistocks/shared/utils/enum-utils';

export const dateConstantOptions = mapEnumToOptions(DateConstant, 'DateConstant');
